import store from '@/store'
import moment from 'moment'

export class ServicesHelper {
  static getBlankService (machineId = null) {
    return {
      machineId,
      status: 'active',
      timestampStarted: moment().unix(),
      timestampCompleted: 0,
      userStarted: `${store.getters.user.firstName} ${store.getters.user.lastName}`,
      userIdStarted: store.getters.user.uid,
      userCompleted: null,
      userIdCompleted: null,
      notes: [],
      checkList: null
    }
  }
}
